import React, { useEffect, useState, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useRecoilValue } from 'recoil';
import { Form, Input, Button, Checkbox, Row, Col, Typography, Flex, Radio, Switch, Slider, Tag } from 'antd';
import { CopyOutlined, ExportOutlined } from '@ant-design/icons';
import { appConfigAtomState } from '../../../state/reducerAtoms/app.atom';

import { translateThis } from '../../../helpers/language.helper';

import { showSnackbar } from '../../../components/snackbar/index';
import ApiCaller from '../../../services/api/general';
import './index.scss';
import { getCurrentFacilityURL } from '../../../helpers/helper.functions';
import SVGIcons from '../../../assets/images/icons/svgIcons';
import './chat.scss';
import AppIcons from '../../../assets/images/icons';
import TypingEffect from '../../../components/texts/typingEffect';
import PageLayout from '../../app';
import AvatarViewer from '../../../components/iconPicker/avatarViewer';
import MultipleFileUpload from '../../../components/multipleFileUpload';
import S3DocumentUploader from '../../../components/awsS3DocumentUploader/document.uploader';
import LogoUploader from '../../../components/agentLogoUploader/logoUploader';
import LogoPreview from '../../../components/logoPreview/logoPreview';
import { uploadLogo } from '../../../services/api/aws';


const { Title, Paragraph } = Typography;

export default function AIViewModule() {
    const appState = useRecoilValue(appConfigAtomState);

    const navigate = useNavigate();
    const { id } = useParams();
    const [isLoading, setIsLoading] = useState(true);
    const [questions, setQuestions] = useState([]);
    const [question, setQuestion] = useState('');
    const [chatContextId, setChatContextId] = useState('');
    const [isChatHistoryLoading, setIsChatHistoryLoading] = useState(false);
    const [isAsking, setIsAsking] = useState(false);
    const [isTextTraining, setIsTextTraining] = useState(false);
    const [trainText, setTrainText] = useState('');
    const [trainTextTitle, setTrainTextTitle] = useState('');
    const [uploadedDocuments, setUploadedDocuments] = useState([]);
    const [avatarIcon, setAvatarIcon] = useState('');
    const [widgetMode, setWidgetMode] = useState('bubble');
    
    const [formData, setFormData] = useState({
        // name: '',
        // title: '',
        // description: '',
        // role: '',
        // mode: '',
        // useCase: '',
        // personality: '',
        // customPrompt: '',
        // connectWithChatBot: false,
        // training: {},
        // parameters: {},
        // documents: []
        name: '',
        title: '',
        description: '',
        role: '',
        mode: '',
        modelVersion: '',
        useCase: '',
        personality: '',
        agentName: '',
        defaultLanguage: '',
        dynamicPrompt: '',
        dynamicPromptStatus: false,
        training: {},
        parameters: {},
        createdCode: '',
        widgetMode,
        avatarImg: avatarIcon,
        conversationBoxTitle: '',
        customPrompt: '',
        connectWithChatBot: false,
        documents: [],
        isHeaderPresent: false,
        isAddRotatingAvatarAndLogo: false,
        themeBackgroundColor: '',
        customChatHeader: '',
        chatLogoImg: '',
        selectPreview: 'desktop',
        agentType: 'customer_support',
        salesConfig: {
            enabledFields: { interestIn: true, goal: true, timelineUrgency: true },
            qualificationQuestions: []
        }
    });


    const [uploadedLogo, setUploadedLogo] = useState(null);
    const handleLogoUpload = (e) => {
        const file = e.target.files[0];
        if (!file) return;
        uploadLogo(file, (result) => {
            if (result.success) {
                setFormValue('chatLogoImg', result.preview);
                setUploadedLogo({ file, preview: result.preview });
            }
        });
    };

    useEffect(() => {
        if (id) {
            getData(id);
        }
        // eslint-disable-next-line
    }, [id]);

    // get data from api
    const getData = (id) => {
        setIsLoading(true);
        const apiCaller = new ApiCaller('modules');
        apiCaller.getData(id)
            .then(({ data }) => {
                const formData = {
                    name: data?.name ?? '',
                    title: data?.title ?? '',
                    description: data?.description ?? '',
                    mode: data?.mode ?? '',
                    modelVersion: data?.modelVersion ?? 'gpt-4.1',
                    defaultLanguage: data?.defaultLanguage ?? '',
                    role: data?.role?.name ?? 'university',
                    useCase: data?.useCase ?? '',
                    personality: data?.personality,
                    connectWithChatBot: data?.connectWithChatBot ?? false,
                    training: data?.training ?? {},
                    dynamicPrompt: data?.dynamicPrompt ?? '',
                    agentName: data?.agentName ?? '',
                    dynamicPromptStatus: data?.dynamicPromptStatus ?? false,
                    parameters: data?.parameters ?? {},
                    customPrompt: data?.customPrompt ?? '',
                    documents: data?.documents ?? [],
                    conversationBoxTitle: data?.conversationBoxTitle ?? '',
                    createdCode: data?.createdCode ?? '',
                    widgetMode: data?.widgetMode ?? '',
                    avatarImg: data?.avatarImg ?? '',
                    chatHeaderImg: data?.chatHeaderImg ?? '',
                    isHeaderPresent: data?.isHeaderPresent ?? false,
                    isAddRotatingAvatarAndLogo: data?.isAddRotatingAvatarAndLogo ?? false,
                    themeBackgroundColor: data?.themeBackgroundColor ?? '',
                    customChatHeader: data?.customChatHeader ?? '',
                    chatLogoImg: data?.chatLogoImg ?? '',
                    selectPreview: data?.selectPreview ?? 'desktop',
                    agentType: data?.agentType ?? 'customer_support',
                    salesConfig: data?.salesConfig ?? {
                        enabledFields: { interestIn: true, goal: true, timelineUrgency: true },
                        qualificationQuestions: []
                    }
                    // ...data
                }
                console.log(formData, 'formDataformData');
                setFormData(formData);
                setWidgetMode(data?.widgetMode || 'bubble');
                if (data?.chatLogoImg && !data.chatLogoImg.startsWith('blob:')) {
                    setUploadedLogo({ preview: data.chatLogoImg });
                } else {
                    setUploadedLogo(null);
                }
                setUploadedDocuments(data?.documents || []);
                setSelectedAvatar(formData?.avatarImg || '');
                setSelectedHeader(formData?.chatHeaderImg || '');
            })
            .catch(() => showSnackbar().failure(`${translateThis('Something went wrong')}`))
            .finally(() => {
                setIsLoading(false);
                getAIChatHistory(id);
            });
    }



    // get data from api
    const getAIChatHistory = (id) => {
        setIsChatHistoryLoading(true);
        const apiCaller = new ApiCaller('ai');
        apiCaller.getData(`modules/${id}/questions`)
            .then((data) => {
                setQuestions(data?.questions ?? [])
                if (data?.questions?.length) {
                    setChatContextId(data?.questions[0].contextId);
                }
            })
            .catch(() => showSnackbar().failure(`${translateThis('Something went wrong')}`))
            .finally(() => setIsChatHistoryLoading(false));
    }

    /**
   * sets the form data 
   * @param {string} name the name of the field
   * @param {string} value  the value of the field
   */
    const setFormValue = (name, value) => {
        setFormData((prv) => ({ ...prv, [name]: value }))

    }

    /**
     * On submit the form
     */
    const askAi = (question) => {
        if (question) {
            // Submitting data to backend for registration
            setIsAsking(true);
            setQuestions((prv) => ([...prv, { question, answer: '' }]));
            const functionToCall = postData;
            functionToCall(formData).then((data) => {
                if (data.success) {
                    setQuestions((prev) => {
                        // Create a new array by removing the last object and adding the new one
                        const newQuestions = prev.slice(0, -1); // Remove the last object
                        newQuestions.push({ question, answer: data?.data?.answer, answerFormatted: data?.data?.answerFormatted }); // Add the new object
                        return newQuestions; // Return the new array
                    });
                    setChatContextId(data?.data?.contextId);
                } else {
                    showSnackbar().failure(data.message);
                }
            }).finally(() => setIsAsking(false));

        }

    };


    /**
     * On submit the form
     */
    const connectWithChatBot = (isConnect) => {
        if (id) {
            // Submitting data to backend for connecting module
            const apiCaller = new ApiCaller('modules');
            apiCaller.customPostData(`/${id}/connect-with-bot`, { isConnect })
                .then((data) => {
                    setFormData((p) => ({ ...p, connectWithChatBot: isConnect }))
                    if (!data.success) {
                        showSnackbar().failure(data.message);
                    }
                });
        }

    };

    /**
     * On submit the form
     */
    const postTrainText = () => {
        if (trainText && trainTextTitle) {
            // Submitting data to backend for registration
            setIsTextTraining(true);
            const apiCaller = new ApiCaller('ai');
            apiCaller.customPostData(`/modules/${id}/train-text`, { text: trainText, title: trainTextTitle })
                .then((data) => {
                    if (data.success) {
                        showSnackbar().success(`${translateThis('Training text added successfully')}`);
                    } else {
                        showSnackbar().failure(data.message);
                    }
                }).finally(() => setIsTextTraining(false));

        }

    };


    /**
     * To save a module
     */
    const postData = async () => {
        const apiCaller = new ApiCaller('ai');
        return apiCaller.customPostData(`/modules/${id}/ask`, { question, contextId: chatContextId || undefined });
    }

    /**
     * To delete a document
     */
    const deleteDocument = async (docTitle) => {
        const apiCaller = new ApiCaller('ai');
        apiCaller.customPostData(`/modules/${id}/delete-document`, { title: docTitle, moduleId: id }).then(({ data }) => {
            if (data?.documents) {
                setUploadedDocuments(data?.documents)
            }
        })
    }

    // get data from api
    const refreshDocuments = () => {
        const apiCaller = new ApiCaller('modules');
        apiCaller.getData(id)
            .then(({ data }) => {
                setUploadedDocuments(data?.documents || []);
            });
    }

    // const marks = [
    //     {
    //         value: 0,
    //         label: <>0<br /><i>{translateThis('Simple')}</i></>,
    //     },
    //     {
    //         value: 0.5,
    //         label: '0.5',
    //     },
    //     {
    //         value: 1,
    //         label: '1',
    //     },
    //     {
    //         value: 1.5,
    //         label: '1.5',
    //     },
    //     {
    //         value: 2,
    //         label: <>2<br /><i>{translateThis('Creative')}</i></>,
    //     },
    // ];




    const marks = {
        0: (
            <>
                0<br />
                <i>{translateThis('Simple')}</i>
            </>
        ),
        0.5: '0.5',
        1: '1',
        1.5: '1.5',
        2: (
            <>
                2<br />
                <i>{translateThis('Creative')}</i>
            </>
        ),
    };





    const chatScrollToBottomRef = useRef(null);
    useEffect(() => {
        if (chatScrollToBottomRef.current) {
            chatScrollToBottomRef.current.scrollTop = chatScrollToBottomRef.current.scrollHeight;
        }
    }, [questions]);


    const moduleEmbeddedURL = `${process.env.REACT_APP_AI_APP_URL}/${getCurrentFacilityURL()}/chat/${formData.name}`;
    const copyEmbeddingURL = () => {
        navigator.clipboard.writeText(moduleEmbeddedURL)
            .then(() => {
                showSnackbar().info(`${translateThis('URL Copied to clipboard')}`)
            });
    }

    const copyEmbedCodeSnippet = () => {
        if (!formData.createdCode) return;
        navigator.clipboard.writeText(formData.createdCode)
            .then(() => showSnackbar().info(`${translateThis('Code Copied to clipboard')}`))
            .catch(() => showSnackbar().warning(`${translateThis('Unable to copy. Please copy manually.')}`));
    };



    const avatarIconList = [
        {
            iconName: AppIcons.avatar1,
            fileKey: 'avatar1',
        },
        {
            iconName: AppIcons.avatar2,
            fileKey: 'avatar2',
        },
        {
            iconName: AppIcons.avatar3,
            fileKey: 'avatar3',
        },
        {
            iconName: AppIcons.avatar4,
            fileKey: 'avatar4',
        },
        {
            iconName: AppIcons.avatar5,
            fileKey: 'avatar5',
        },
        {
            iconName: AppIcons.avatar6,
            fileKey: 'avatar6',
        },
        {
            iconName: AppIcons.avatar7,
            fileKey: 'avatar7',
        },
        {
            iconName: AppIcons.avatar8,
            fileKey: 'avatar8',
        },
        {
            iconName: AppIcons.avatar9,
            fileKey: 'avatar9',
        },
        {
            iconName: AppIcons.avatar10,
            fileKey: 'avatar10',
        },
        {
            iconName: AppIcons.avatar11,
            fileKey: 'avatar11',
        },
        {
            iconName: AppIcons.avatar12,
            fileKey: 'avatar12',
        },
        {
            iconName: AppIcons.avatar13,
            fileKey: 'avatar13',
        },
        {
            iconName: AppIcons.avatar14,
            fileKey: 'avatar14',
        },
        {
            iconName: AppIcons.avatar15,
            fileKey: 'avatar15',
        },
        {
            iconName: AppIcons.avatar16,
            fileKey: 'avatar16',
        },
        {
            iconName: AppIcons.avatar17,
            fileKey: 'avatar17',
        },
    ];

    const humanLookAvatar = [
        {
            iconName: AppIcons.hAvatar1,
            fileKey: 'hAvatar1',
        },
        {
            iconName: AppIcons.hAvatar2,
            fileKey: 'hAvatar2',
        },
        {
            iconName: AppIcons.hAvatar3,
            fileKey: 'hAvatar3',
        },
        {
            iconName: AppIcons.hAvatar4,
            fileKey: 'hAvatar4',
        },
        {
            iconName: AppIcons.hAvatar5,
            fileKey: 'hAvatar5',
        },
        {
            iconName: AppIcons.hAvatar6,
            fileKey: 'hAvatar6',
        },
        {
            iconName: AppIcons.hAvatar7,
            fileKey: 'hAvatar7',
        },
        {
            iconName: AppIcons.hAvatar8,
            fileKey: 'hAvatar8',
        },
        {
            iconName: AppIcons.hAvatar9,
            fileKey: 'hAvatar9',
        },
        {
            iconName: AppIcons.hAvatar10,
            fileKey: 'hAvatar10',
        },

    ];

    const botLookAvatar = [
        {
            iconName: AppIcons.bAvatar1,
            fileKey: 'bAvatar1',
        },
        {
            iconName: AppIcons.bAvatar2,
            fileKey: 'bAvatar2',
        },
        {
            iconName: AppIcons.bAvatar3,
            fileKey: 'bAvatar3',
        },
        {
            iconName: AppIcons.bAvatar4,
            fileKey: 'bAvatar4',
        },
        {
            iconName: AppIcons.bAvatar5,
            fileKey: 'bAvatar5',
        },
        {
            iconName: AppIcons.bAvatar6,
            fileKey: 'bAvatar6',
        },
        {
            iconName: AppIcons.bAvatar7,
            fileKey: 'bAvatar7',
        },
        {
            iconName: AppIcons.bAvatar8,
            fileKey: 'bAvatar8',
        },
        {
            iconName: AppIcons.bAvatar9,
            fileKey: 'bAvatar9',
        },
        {
            iconName: AppIcons.bAvatar10,
            fileKey: 'bAvatar10',
        },
        {
            iconName: AppIcons.bAvatar11,
            fileKey: 'bAvatar11',
        },
        {
            iconName: AppIcons.bAvatar12,
            fileKey: 'bAvatar12',
        },
        {
            iconName: AppIcons.bAvatar13,
            fileKey: 'bAvatar13',
        },
        {
            iconName: AppIcons.bAvatar14,
            fileKey: 'bAvatar14',
        },
        {
            iconName: AppIcons.bAvatar15,
            fileKey: 'bAvatar15',
        },
        {
            iconName: AppIcons.bAvatar16,
            fileKey: 'bAvatar16',
        },
        {
            iconName: AppIcons.bAvatar17,
            fileKey: 'bAvatar17',
        },
        {
            iconName: AppIcons.bAvatar18,
            fileKey: 'bAvatar18',
        },
        {
            iconName: AppIcons.bAvatar19,
            fileKey: 'bAvatar19',
        },

    ];


    const [selectedAvatar, setSelectedAvatar] = useState(null); // This can be a unique ID or key

    const avatarSelect = (element) => {
        if (selectedAvatar === element) {
            setSelectedAvatar(null); // Deselect on second click
        } else {
            setSelectedAvatar(element);
        }
        setAvatarIcon(element.fileKey);
    };

    const [selectedHeader, setSelectedHeader] = useState(formData?.chatHeaderImg || 'header1');

    // Optional: Update preview if formData changes externally
    useEffect(() => {
        if (formData?.chatHeaderImg) {
            setSelectedHeader(formData.chatHeaderImg);
        }
        if (formData?.avatarImg) {
            setAvatarIcon(formData.avatarImg);
        }
    }, [formData]);

    const handleHeaderChange = (e) => {
        const value = e.target.value;
        setSelectedHeader(value);
        setFormValue('chatHeaderImg', value);
    };


    const headerImages = {
        header1: AppIcons.chatHead1,
        header2: AppIcons.chatHead2,
        header3: AppIcons.chatHead3,
        header4: AppIcons.chatHead4,
        header5: AppIcons.chatHead5,
        header6: AppIcons.chatHead6,
        header7: AppIcons.chatHead7,
    };

    const scrollToTop = useRef(null);
    const [currentFormStep, setCurrentFormStep] = useState(0);
    const totalSteps = 4;

    const getSectionClass = (index) => {
        if (index < currentFormStep) return 'completed';
        if (index === currentFormStep) return 'progress';
        return 'upcoming';
    };


    return (

        <PageLayout
            pageName={'products'}
            pageTitle={'Products'}
            bodyClassName={`module-main-wrp`}
            key={`${appState?.selectedLang}`}
            hideHeaderOnScroll
        >

            <div className='main-content-wrapper AI-module-view f-wrp' ref={scrollToTop}>

                <div className='appForm-layout'>
                    <br />
                    {!isLoading ? <Form
                        name="moduleView"
                        // disabled={!isEditEnabled}
                        initialValues={formData}
                        // onFinish={onFinish}
                        // onFinishFailed={onFinishFailed}
                        layout="vertical"
                    >
                        <div className="container">
                            <Flex gap={0} justify='space-between' vertical="true">

                                <Flex horizontal="true" className='sticky-stepper'>
                                    <div className='stepper-box f-wrp'>
                                        <button type='button' onClick={() => { setCurrentFormStep(0); scrollToTop.current?.scrollIntoView({ behavior: 'smooth' }); }} className={`each-step-items ${getSectionClass(0)}`}>
                                            <p>{translateThis('Create')}</p>
                                        </button>
                                        <button type='button' onClick={() => { setCurrentFormStep(1); scrollToTop.current?.scrollIntoView({ behavior: 'smooth' }); }} className={`each-step-items ${getSectionClass(1)}`}>
                                            <p>{translateThis('Train')}</p>
                                        </button>
                                        <button type='button' onClick={() => { setCurrentFormStep(2); scrollToTop.current?.scrollIntoView({ behavior: 'smooth' }); }} className={`each-step-items ${getSectionClass(2)}`}>
                                            <p>{translateThis('Design')}</p>
                                        </button>
                                        <button type='button' onClick={() => { setCurrentFormStep(3); scrollToTop.current?.scrollIntoView({ behavior: 'smooth' }); }} className={`each-step-items ${getSectionClass(3)}`}>
                                            <p>{translateThis('Deploy')}</p>
                                        </button>
                                    </div>
                                </Flex>
                                {/* -------------------------------------- start of page one ----------------------------------------- */}

                                {currentFormStep === 0 ?
                                    <Row gutter={90}>
                                        <Col span={24}><br /><br /></Col>
                                        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Module title')} 🏷️</Title>
                                            <Paragraph>{translateThis('Choose who your AI becomes this role guides how it interacts with users.')}</Paragraph>
                                            <Form.Item
                                                label={translateThis('Module title')}
                                                name="title"
                                                rules={[{ required: true, message: `${translateThis('Please enter Module title here')}` }]}
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Input disabled placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('For use of ...')}</Title>
                                            <Paragraph>&nbsp;</Paragraph>
                                            <br />
                                            <Form.Item
                                                name="role"
                                                initialValue={formData?.role}
                                                style={{ marginBottom: '52px' }}
                                            >

                                                <Radio.Group
                                                    initialValue={formData?.role}
                                                    defaultValue={formData?.role}
                                                    disabled
                                                >
                                                    <Radio value="university">{translateThis("Internal (Only your team can access)")}</Radio>
                                                    <Radio value="student">{translateThis("Public (For use of your clients /audience )")}</Radio>
                                                </Radio.Group>
                                            </Form.Item>

                                        </Col>
                                        <Col span={24}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Description')} 📌</Title>
                                            <Paragraph>{translateThis('Briefly describe the purpose of this assistant and what it’s meant to help with.')}</Paragraph>
                                            <Form.Item
                                                label={translateThis("Description")}
                                                name="description"
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Input.TextArea disabled autoSize={{ minRows: 4, maxRows: 7 }}
                                                    style={{ resize: 'vertical' }} placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>

                                        {/* -------- Agent Type (read-only) -------- */}
                                        <Col span={24}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Agent Type')} 🎯</Title>
                                            <Paragraph>{translateThis('Choose the type of agent. This determines ticket behavior automatically.')}</Paragraph>
                                            <Form.Item
                                                name="agentType"
                                                initialValue={formData?.agentType}
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Radio.Group disabled value={formData.agentType}>
                                                    <Radio value="customer_support">{translateThis('Customer Support')}</Radio>
                                                    <Radio value="sales">{translateThis('Sales')}</Radio>
                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>

                                        {/* -------- Sales Configuration (read-only, sales agents only) -------- */}
                                        {formData.agentType === 'sales' && (() => {
                                            const ef = formData.salesConfig?.enabledFields || {};
                                            const qs = formData.salesConfig?.qualificationQuestions || [];
                                            const FIELD_LABEL = { interestIn: 'Interest In', goal: 'Goal', timelineUrgency: 'Timeline' };
                                            const FIELD_COLOR = { interestIn: 'blue', goal: 'green', timelineUrgency: 'orange' };
                                            const QUAL_FIELDS = [
                                                { key: 'interestIn', label: 'Interest In' },
                                                { key: 'goal', label: 'Goal' },
                                                { key: 'timelineUrgency', label: 'Timeline / Urgency' },
                                            ];
                                            return (
                                                <Col span={24}>
                                                    <div style={{
                                                        background: 'linear-gradient(135deg, rgba(117, 23, 248, 0.05) 0%, rgba(196, 56, 239, 0.05) 100%)',
                                                        border: '1px solid rgba(117, 23, 248, 0.2)',
                                                        borderRadius: '12px',
                                                        padding: '24px',
                                                        marginBottom: '52px'
                                                    }}>
                                                        {/* Enabled fields */}
                                                        <Title level={5} style={{ margin: '0 0 4px 0' }}>{translateThis('Sales Qualification Fields')} 📊</Title>
                                                        <Paragraph style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', marginBottom: '16px' }}>
                                                            {translateThis('Only enabled fields will be collected, extracted, and stored.')}
                                                        </Paragraph>
                                                        <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', marginBottom: '24px' }}>
                                                            {QUAL_FIELDS.map(({ key, label }) => (
                                                                <div key={key} style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                                                                    <Switch disabled checked={ef[key] !== false} size="small" />
                                                                    <span style={{ color: '#fff' }}>{translateThis(label)}</span>
                                                                </div>
                                                            ))}
                                                        </div>

                                                        {/* Questions */}
                                                        <Title level={5} style={{ margin: '0 0 4px 0' }}>{translateThis('Qualification Questions')} ❓</Title>
                                                        <Paragraph style={{ fontSize: '12px', color: 'rgba(255,255,255,0.65)', marginBottom: '16px' }}>
                                                            {translateThis('Questions the agent asks to qualify each lead.')}
                                                        </Paragraph>
                                                        {qs.length === 0 && (
                                                            <Paragraph style={{ fontSize: '12px', color: 'rgba(255,255,255,0.4)', textAlign: 'center', padding: '12px 0' }}>
                                                                {translateThis('No qualification questions configured.')}
                                                            </Paragraph>
                                                        )}
                                                        {qs.map((q, idx) => (
                                                            <div key={idx} style={{
                                                                display: 'flex', alignItems: 'center', gap: '8px',
                                                                padding: '10px 12px', background: 'rgba(255,255,255,0.07)',
                                                                borderRadius: '8px', marginBottom: '8px',
                                                                border: '1px solid rgba(255,255,255,0.1)',
                                                                opacity: q.enabled !== false ? 1 : 0.5
                                                            }}>
                                                                <Switch disabled checked={q.enabled !== false} size="small" />
                                                                <span style={{ flex: 1, fontSize: '13px', color: '#fff' }}>{q.question}</span>
                                                                <Tag color={FIELD_COLOR[q.mapping] || 'default'} style={{ margin: 0 }}>
                                                                    {translateThis(FIELD_LABEL[q.mapping] || q.mapping)}
                                                                </Tag>
                                                            </div>
                                                        ))}
                                                    </div>
                                                </Col>
                                            );
                                        })()}

                                        <Col span={24}>
                                            <Row gutter={24} style={{ marginTop: 20 }}>

                                                {/* Left side — Source */}
                                                <Col xs={24} md={12}>
                                                    <Title level={4} style={{ margin: 0 }}>
                                                        {translateThis('Source')} 🎛️
                                                    </Title>
                                                    <Paragraph>&nbsp;</Paragraph>

                                                    <Form.Item name="mode" initialValue={formData?.mode} style={{ marginBottom: 32 }}>
                                                        <Radio.Group disabled className="custom-radio-group">
                                                            <Radio value="trained">{translateThis('Trained')}</Radio>
                                                            <Radio value="gpt">{translateThis('ChatGPT')}</Radio>
                                                            <Radio value="combined">{translateThis('Combined')}</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>

                                                {/* Right side — GPT version */}
                                                <Col xs={24} md={12}>
                                                    <Title level={4} style={{ margin: 0 }}>
                                                        {translateThis('GPT version')}
                                                    </Title>
                                                    <Paragraph>&nbsp;</Paragraph>

                                                    <Form.Item
                                                        name="modelVersion"
                                                        initialValue={formData?.modelVersion}
                                                        style={{ marginBottom: 32 }}
                                                    >
                                                        <Radio.Group disabled className="custom-radio-group">
                                                            <Radio value="gpt-4.1">GPT 4.1</Radio>
                                                            <Radio value="gpt-5.1">GPT 5.1</Radio>
                                                            <Radio value="gpt-5.2">GPT&nbsp;5.2</Radio>
                                                            <Radio value="gpt-5.2-pro">GPT&nbsp;5.2-Pro</Radio>
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>

                                            </Row>

                                        </Col>

                                        <Col span={12}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Give life to your AI ...')} 🚀</Title>
                                            <Paragraph>&nbsp;</Paragraph>
                                            <Form.Item
                                                label={translateThis("Name your agent")}
                                                name="agentName"
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Input
                                                    value={formData.agentName}
                                                    disabled
                                                    onChange={(e) => setFormValue('agentName', e.target.value)}
                                                    placeholder={translateThis('Type here')} />
                                            </Form.Item>

                                        </Col>

                                        <Col span={24}>
                                            <Row gutter={5}>
                                                <Col span={24}>

                                                    <Form.Item name={"Connect_this_model_with_Asclepius"} valuePropName="checked" style={{ marginBottom: '52px' }}>
                                                        <Checkbox
                                                            checked={formData?.connectWithChatBot}
                                                            onChange={(e) => connectWithChatBot(e.target.checked)}
                                                        >
                                                            {translateThis("Connect this model with Main model")}
                                                        </Checkbox>
                                                    </Form.Item>
                                                </Col>

                                            </Row>
                                        </Col>

                                        <Col span={24} style={{ marginBottom: '60px' }}>
                                            <Title level={4} style={{ margin: '0', fontWeight: '400' }}>{translateThis('How does it look like?')}</Title>
                                            <br />
                                            <Title level={5} style={{ margin: '0' }}>{translateThis('3D avatar look')}</Title>
                                            <br />

                                            <Flex className='avatar-list' horizontal gap={14} wrap>
                                                {avatarIconList.map((element, key) => (
                                                    <Button key={key} disabled
                                                        className={`avatar-btn ${formData?.avatarImg === element.fileKey ? 'selected' : ''}`}
                                                        icon={<img src={element.iconName} alt="icon" style={{ width: '100%', height: '100%' }} />}
                                                        shape="circle" onClick={() => setFormValue('avatarImg', element.fileKey)}
                                                    />
                                                ))}
                                            </Flex>

                                            <br />
                                            <Title level={5} style={{ margin: '0' }}>{translateThis('Real human look')}</Title>
                                            <br />
                                            <Flex className='avatar-list' horizontal gap={14} wrap>
                                                {humanLookAvatar.map((element, key) => (
                                                    <Button key={key} disabled
                                                        className={`avatar-btn ${formData?.avatarImg === element.fileKey ? 'selected' : ''}`}
                                                        icon={<img src={element.iconName} alt="icon" style={{ width: '100%', height: '100%' }} />}
                                                        shape="circle" onClick={() => setFormValue('avatarImg', element.fileKey)}
                                                    />
                                                ))}
                                            </Flex>
                                            <br />
                                            <Title level={5} style={{ margin: '0' }}>{translateThis('Bot look')}</Title>
                                            <br />
                                            <Flex className='avatar-list' horizontal gap={14} wrap>
                                                {botLookAvatar.map((element, key) => (
                                                    <Button key={key} disabled
                                                        className={`avatar-btn ${formData?.avatarImg === element.fileKey ? 'selected' : ''}`}
                                                        icon={<img src={element.iconName} alt="icon" style={{ width: '100%', height: '100%' }} />}
                                                        shape="circle" onClick={() => setFormValue('avatarImg', element.fileKey)}
                                                    />
                                                ))}
                                            </Flex>
                                        </Col>
                                    </Row> : null}

                                {/* -------------------------------------- end of page one ----------------------------------------- */}

                                {currentFormStep === 1 ?
                                    <Row gutter={90}>
                                        <Col span={24}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Purpose of the Module / Use case')}</Title>
                                            <Paragraph>{translateThis('Here enter the purpose of this module or the use cases for which it will be applied the AI.')}</Paragraph>
                                            <Form.Item
                                                label={translateThis("Purpose / Use case")}
                                                name="useCase"
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Input.TextArea disabled autoSize={{ minRows: 4, maxRows: 7 }}
                                                    style={{ resize: 'vertical' }} placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>
                                        {/* -------------------- Chat Behaviour (VIEW ONLY) -------------------- */}
                                        <Col span={24}>
                                            <br />
                                            <Title level={4} style={{ margin: 0 }}>{translateThis('Chat Behaviour')} 🧩</Title>
                                            <Paragraph>{translateThis('Choose what the bot should ask before starting the conversation.')}</Paragraph>

                                            {/* Ask name */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 13, marginBottom: 14 }}>
                                                <Switch disabled checked={!!formData?.training?.chatBehaviour?.askName} />
                                                <Paragraph style={{ margin: 0 }}>{translateThis('Ask User Name')}</Paragraph>
                                            </div>

                                            {/* Ask email */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 13, marginBottom: 14 }}>
                                                <Switch disabled checked={!!formData?.training?.chatBehaviour?.askEmail} />
                                                <Paragraph style={{ margin: 0 }}>{translateThis('Ask User Email')}</Paragraph>
                                            </div>

                                            {/* Instruction field */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 13, marginBottom: 14 }}>
                                                <Switch disabled checked={!!formData?.training?.chatBehaviour?.askUserGoal} />
                                                <Paragraph style={{ margin: 0 }}>{translateThis('Show custom introduction message to User')}</Paragraph>
                                            </div>

                                            {/* Instruction text */}
                                            {formData?.training?.chatBehaviour?.askUserGoal ? (
                                                <Form.Item
                                                    label={translateThis('Message')}
                                                    style={{ marginTop: 12, marginBottom: 52 }}
                                                >
                                                    <Input.TextArea
                                                        disabled
                                                        value={formData?.training?.chatBehaviour?.userGoalText || ''}
                                                        autoSize={{ minRows: 3, maxRows: 6 }}
                                                        style={{ resize: 'vertical' }}
                                                        placeholder={translateThis('Type anything here')}
                                                    />
                                                </Form.Item>
                                            ) : (
                                                <div style={{ marginBottom: 14 }} />
                                            )}

                                            {/* Human agent handoff */}
                                            <div style={{ display: 'flex', alignItems: 'center', gap: 13, marginBottom: 52 }}>
                                                <Switch disabled checked={!!formData?.training?.chatBehaviour?.humanHandoff?.enabled} />
                                                <Paragraph style={{ margin: 0 }}>{translateThis('Enable Human Agent Handoff')}</Paragraph>
                                            </div>
                                        </Col>
                                        {/* -------------------- /Chat Behaviour (VIEW ONLY) -------------------- */}

                                        {id ? <Col span={24}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Upload training files')} 👟</Title>
                                            <Paragraph>{translateThis('Upload documents, conversations, or data sets that the assistant will use to learn and improve its responses. Accepted formats: .txt, .csv, .pdf, .docx.')}</Paragraph>
                                            <br />



                                            <div className='form-img-uploader f-wrp'>
                                                <MultipleFileUpload
                                                    folderId={`${id}` ?? ''}
                                                    uploadURL={`ai/modules/${id}/documents`}
                                                    uploadIcon={SVGIcons.UploadFileIcon()}
                                                    uploadCaption={`${translateThis('Upload files here')}`}
                                                    uploadedDocuments={(id ? uploadedDocuments : null) || []}
                                                    onSuccess={refreshDocuments}
                                                    onClose={refreshDocuments}
                                                    onDeleteFile={(fileName) => deleteDocument(fileName)}
                                                />
                                                {/* <S3DocumentUploader
                                                    acceptOnly='*'
                                                    uploadIcon={SVGIcons.UploadFileIcon()}
                                                    uploadCaption={`${translateThis('Upload files here')}`}
                                                    uploadURL={`ai/modules/${id}/documents`}
                                                    onUploadEnd={(file) => setUploadedDocuments((prev) => {
                                                        const newImgArr = [...prev];
                                                        newImgArr.push(file);
                                                        return [...newImgArr];
                                                    })}
                                                /> */}
                                            </div>


                                            <br />
                                        </Col> : null}
                                        <Col span={24}>
                                            <br />
                                            <br />
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Training / Fine tunning')} 🔧</Title>
                                            <Paragraph>{translateThis('Provide detailed instructions, expected behavior, logical reasoning, boundaries, and examples to guide how the assistant should interact with users. These inputs help define tone, style, and specific actions to improve performance and consistency')}</Paragraph>
                                            <Form.Item
                                                label={translateThis("Training / Fine tunning")}
                                                name={['training', 'instructions']}
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Input.TextArea disabled autoSize={{ minRows: 4, maxRows: 7 }}
                                                    style={{ resize: 'vertical' }} placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Training text')}</Title>
                                            <Paragraph>{translateThis('Add real-life examples or FAQs to train your assistant with accurate replies.')}</Paragraph>
                                            <Form.Item
                                                label={translateThis("Training text title")}
                                                initialValue={trainTextTitle}
                                                name="trainTextTitle"
                                                style={{ marginBottom: '20px' }}
                                            >
                                                <Input value={trainTextTitle} onChange={(e) => setTrainTextTitle(e.target.value)} placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Form.Item
                                                label={translateThis("Training text content")}
                                                initialValue={trainText}
                                                name="trainText"
                                                style={{ marginBottom: '30px' }}
                                            >
                                                <Input.TextArea value={trainText} onChange={(e) => setTrainText(e.target.value)} autoSize={{ minRows: 4, maxRows: 7 }}
                                                    style={{ resize: 'vertical' }} placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Button type="primary" disabled={!trainText || !trainTextTitle || isTextTraining}
                                                onClick={() => postTrainText()}
                                                className='upload-file-btn'
                                                icon={<SVGIcons.UploadFileIcon />}>
                                                {translateThis("Train")}
                                            </Button>
                                        </Col>
                                        <Col span={24}>
                                            <br />
                                            <br />
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Training Examples')}</Title>
                                            <Paragraph>&nbsp;</Paragraph>
                                            <div className='training-example-box f-wrp'>
                                                {formData.training?.examples?.length ? formData.training?.examples?.map((q, i) =>
                                                    <Row gutter={90} key={i}>
                                                        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                                                            <Form.Item
                                                                label={translateThis("Training text title")}
                                                                initialValue={q.question}
                                                                style={{ marginBottom: '20px' }}
                                                            >
                                                                <Input value={q.question} placeholder={translateThis('Type here')} />
                                                            </Form.Item>
                                                        </Col>

                                                        <Col span={24}>
                                                            <Form.Item
                                                                label={translateThis("Training text content")}
                                                                initialValue={q.answer}
                                                                style={{ marginBottom: '20px' }}
                                                            >
                                                                <Input.TextArea value={q.answer} autoSize={{ minRows: 4, maxRows: 7 }}
                                                                    style={{ resize: 'vertical' }} placeholder={translateThis('Type here')} />
                                                            </Form.Item>
                                                        </Col>

                                                    </Row>
                                                ) : null}
                                            </div>

                                        </Col>
                                        <Col span={24}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Setting a Pre-prompt')} 🎯</Title>
                                            <Paragraph>{translateThis("A pre-prompt is a hidden instruction included with every message the user sends to the AI agent. While the user doesn't see it, the AI agent reads it as context before responding helping shape its behavior and tone throughout the conversation.")}</Paragraph>
                                            <br />
                                            <Form.Item style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '13px', marginBottom: '20px' }}>
                                                    <Switch
                                                        checked={formData?.dynamicPromptStatus}
                                                        onChange={(checked) =>
                                                            setFormData((prev) => ({ ...prev, dynamicPromptStatus: checked }))
                                                        }
                                                        style={{ backgroundColor: formData?.dynamicPromptStatus ? 'var(--Accent)' : undefined }}
                                                    />
                                                    <Paragraph style={{ margin: '0' }}>{translateThis("Use custom prompt")}</Paragraph>
                                                </div>

                                                {formData?.dynamicPromptStatus ? <Form.Item
                                                    label={translateThis("Custom prompt")}
                                                    initialValue={formData.dynamicPrompt}
                                                    style={{ marginBottom: '20px' }}
                                                >
                                                    <Input.TextArea disabled value={formData.dynamicPrompt} autoSize={{ minRows: 4, maxRows: 7 }}
                                                        style={{ resize: 'vertical' }} placeholder={translateThis('Type here')} />
                                                </Form.Item> : null}

                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <br />
                                            <br />
                                            <Title level={3} style={{ margin: '0' }}>{translateThis('Personality')} 🎭</Title>
                                            <Paragraph>&nbsp;</Paragraph>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Do you want to choose a tone?')}  🗣️</Title>
                                            <br />
                                            <Form.Item
                                                name="personality"
                                                initialValue={formData?.personality}
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Radio.Group
                                                    style={{
                                                        display: 'flex',
                                                        flexDirection: 'column',
                                                        gap: 12,
                                                    }}
                                                    disabled
                                                    onChange={(e) => setFormValue('personality', e.target.value)}
                                                    className="custom-radio-group"
                                                >
                                                    <Radio value="casual"><p style={{ margin: '0', fontSize: '18px', fontWeight: '500' }}>{translateThis('Casual')} <i style={{ fontStyle: 'normal', fontSize: '14px', fontWeight: '400' }}>{translateThis('(Relaxed tone, like chatting with a friend)')}</i></p></Radio>
                                                    <Radio value="professional but friendly"><p style={{ margin: '0', fontSize: '18px', fontWeight: '500' }}>{translateThis('Professional but Friendly')} <i style={{ fontStyle: 'normal', fontSize: '14px', fontWeight: '400' }}>{translateThis('(Polite and clear, without being too formal)')}</i></p></Radio>
                                                    <Radio value="motivational"><p style={{ margin: '0', fontSize: '18px', fontWeight: '500' }}>{translateThis('Motivational')} <i style={{ fontStyle: 'normal', fontSize: '14px', fontWeight: '400' }}>{translateThis('(Positive, encouraging tone to boost user confidence)')}</i></p></Radio>
                                                    <Radio value="empathetic"><p style={{ margin: '0', fontSize: '18px', fontWeight: '500' }}>{translateThis('Empathetic')} <i style={{ fontStyle: 'normal', fontSize: '14px', fontWeight: '400' }}>{translateThis('(Calming and kind, great for tough or emotional moments)')}</i></p></Radio>
                                                    <Radio value="expert advisor"><p style={{ margin: '0', fontSize: '18px', fontWeight: '500' }}>{translateThis('Expert / Advisor')} <i style={{ fontStyle: 'normal', fontSize: '14px', fontWeight: '400' }}>{translateThis('(Confident and helpful, like a knowledgeable assistant)')}</i></p></Radio>

                                                </Radio.Group>
                                            </Form.Item>

                                        </Col>
                                        <Col span={12} xs={24} sm={24} md={12} lg={12} xl={12}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Temperature')} 🌡️</Title>
                                            <Paragraph>
                                                {translateThis("Set the tone of your AI Agent’s responses. Adjust the creativity level from straightforward and factual to imaginative and expressive using the temperature setting.")}
                                            </Paragraph>
                                            <br />
                                            <Form.Item style={{ marginBottom: '20px' }}>
                                                <div
                                                    className="f-wrp"
                                                    style={{
                                                        marginBottom: '20px',
                                                        maxWidth: '100%',
                                                        width: '100%',
                                                        height: '90px',
                                                        overflowX: 'hidden',
                                                        paddingLeft: '20px',
                                                        paddingRight: '35px',
                                                    }}
                                                >
                                                    <Slider
                                                        style={{ width: '100%', }}
                                                        tooltip={{ open: true }}
                                                        className="slider-bar"
                                                        min={0}
                                                        step={0.05}
                                                        max={2}
                                                        disabled
                                                        defaultValue={formData?.parameters?.temperature || 1}
                                                        marks={marks}
                                                        onChange={(_, v) => setFormValue('parameters', { temperature: v })}
                                                    />
                                                </div>
                                            </Form.Item>
                                        </Col>
                                        <Col span={24}>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Language')}</Title>
                                            <Paragraph>&nbsp;</Paragraph>


                                            <Form.Item
                                                name="defaultLanguage"
                                                initialValue={formData?.defaultLanguage}
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Radio.Group
                                                    onChange={(e) => setFormValue('defaultLanguage', e.target.value)}
                                                    className="custom-radio-group"
                                                    disabled
                                                >
                                                    <Radio value="en">{translateThis('English')}</Radio>
                                                    <Radio value="es">{translateThis('Spanish')}</Radio>
                                                </Radio.Group>
                                            </Form.Item>

                                        </Col>
                                    </Row> : null}

                                {/* -------------------------------------- end of page two ----------------------------------------- */}

                                {currentFormStep === 2 ?
                                    <Row gutter={90}>
                                        <Col span={24}>
                                            <br />
                                            <br />
                                            <Title level={3} style={{ margin: '0' }}>{translateThis('Customize your chatbot’s look and feel')} 🧑‍🎨 </Title>
                                            <Paragraph>&nbsp;</Paragraph>
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Choose your Avatar')}</Title>
                                            <br />

                                            <Flex className='avatar-list' horizontal gap={14} wrap>
                                                {avatarIconList.map((element, key) => (
                                                    <Button key={key} disabled
                                                        className={`avatar-btn ${formData?.avatarImg === element.fileKey ? 'selected' : ''}`}
                                                        icon={<img src={element.iconName} alt="icon" style={{ width: '100%', height: '100%' }} />}
                                                        shape="circle" onClick={() => setFormValue('avatarImg', element.fileKey)}
                                                    />
                                                ))}
                                            </Flex>

                                            <br />
                                            <Title level={5} style={{ margin: '0' }}>{translateThis('Real human look')}</Title>
                                            <br />
                                            <Flex className='avatar-list' horizontal gap={14} wrap>
                                                {humanLookAvatar.map((element, key) => (
                                                    <Button key={key} disabled
                                                        className={`avatar-btn ${formData?.avatarImg === element.fileKey ? 'selected' : ''}`}
                                                        icon={<img src={element.iconName} alt="icon" style={{ width: '100%', height: '100%' }} />}
                                                        shape="circle" onClick={() => setFormValue('avatarImg', element.fileKey)}
                                                    />
                                                ))}
                                            </Flex>
                                            <br />
                                            <Title level={5} style={{ margin: '0' }}>{translateThis('Bot look')}</Title>
                                            <br />
                                            <Flex className='avatar-list' horizontal gap={14} wrap>
                                                {botLookAvatar.map((element, key) => (
                                                    <Button key={key} disabled
                                                        className={`avatar-btn ${formData?.avatarImg === element.fileKey ? 'selected' : ''}`}
                                                        icon={<img src={element.iconName} alt="icon" style={{ width: '100%', height: '100%' }} />}
                                                        shape="circle" onClick={() => setFormValue('avatarImg', element.fileKey)}
                                                    />
                                                ))}
                                            </Flex>
                                        </Col>
                                        <Col span={24}>
                                            <br />
                                            <Paragraph>&nbsp;</Paragraph>
                                            <Title level={3} style={{ margin: '0' }}>{translateThis('Rotating avatar + logo')} 🖼️</Title>
                                            <Paragraph>&nbsp;</Paragraph>

                                            <Form.Item style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '13px', marginBottom: '20px' }}>
                                                    <Switch
                                                        checked={formData?.isAddRotatingAvatarAndLogo}
                                                        onChange={(checked) =>
                                                            setFormData((prev) => ({ ...prev, isAddRotatingAvatarAndLogo: checked }))
                                                        }
                                                        style={{ backgroundColor: formData?.isAddRotatingAvatarAndLogo ? 'var(--Accent)' : undefined }}
                                                    />
                                                    <Paragraph style={{ margin: '0' }}>{translateThis("Add rotating avatar + logo")}</Paragraph>
                                                </div>

                                            </Form.Item>
                                        {/* <div className='logo-upload-box f-wrp'>
                                                <div className='upload-preview'>
                                                    <span>
                                                        <img src={AppIcons.defaultLogo} alt='default logo' />

                                                        <img
                                                            src={uploadedLogo?.url || formData?.chatLogoImg || AppIcons.defaultLogo}
                                                            alt="logo preview"
                                                        />

                                                    </span>
                                                    <p>{translateThis('Default image')}</p>
                                                </div>

                                                <div className='form-img-uploader f-wrp'>
                                                    <S3DocumentUploader
                                                        acceptOnly='image/*'
                                                        uploadIcon={SVGIcons.UploadFileIcon()}
                                                        uploadCaption={`${translateThis('Add logo')}`}
                                                        uploadURL={`ai/modules`}
                                                        onUploadEnd={(file) => { setUploadedLogo(file); console.log(file, 'file') }}
                                                    />
                                                </div>
                                            </div> */}


                                            <div className='logo-upload-box f-wrp'>

                                                {/* 
                                                <div className='form-img-uploader f-wrp'>
                                                    <LogoUploader
                                                        onUpload={(file) => {
                                                            setUploadedLogo(file);
                                                            setFormValue("chatLogoImg", file?.url);
                                                        }}
                                                    />
                                                </div>
                                                */}

                                                <div className="form-img-uploader f-wrp">
                                                    <div className='uploader-box upload-file-btn'>
                                                        <input
                                                            type="file"
                                                            accept="image/*"
                                                            onChange={handleLogoUpload}
                                                            style={{ display: "none" }}
                                                            id="logoUpload"
                                                        />

                                                        <label htmlFor="logoUpload" className="upload-btn">
                                                            {SVGIcons.UploadFileIcon()}
                                                            {translateThis("Add logo")}
                                                        </label>
                                                    </div>
                                                </div>

                                                <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                            </div>



                                        </Col>
                                        <Col span={24}>
                                            <br />
                                            <Paragraph>&nbsp;</Paragraph>
                                            <Title level={3} style={{ margin: '0' }}>{translateThis('Top bar & title')}  📐 </Title>
                                            <Paragraph>&nbsp;</Paragraph>

                                            <Form.Item style={{ marginBottom: '20px' }}>
                                                <div style={{ display: 'flex', alignItems: 'center', gap: '13px', marginBottom: '20px' }}>
                                                    <Switch
                                                        checked={formData?.isHeaderPresent}
                                                        onChange={(checked) =>
                                                            setFormData((prev) => ({ ...prev, isHeaderPresent: checked }))
                                                        }
                                                        style={{ backgroundColor: formData?.isHeaderPresent ? 'var(--Accent)' : undefined }}
                                                    />
                                                    <Paragraph style={{ margin: '0' }}>{translateThis("Add top bar theme ")}( {formData?.isHeaderPresent ? <>{translateThis("On")}</> : <>{translateThis("Off")}</>} )</Paragraph>
                                                </div>

                                            </Form.Item>


                                            <Title level={4} style={{ margin: '0', fontWeight: '400' }}>{translateThis('Theme presets')}</Title>
                                            <Paragraph>&nbsp;</Paragraph>
                                            <br />


                                            <Row gutter={70}>
                                                <Col span={9}>
                                                    <div className='f-wrp chat-preview-box chat-header-box'>
                                                        <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`}>
                                                            {(formData?.isHeaderPresent) ? <img
                                                                className='chat-head'
                                                                src={headerImages[selectedHeader]}
                                                                alt="Selected preview"
                                                            /> : ''}

                                                            <div className='title-box'>
                                                                <div className='logo-upload-box f-wrp'>
                                                                    <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                </div>
                                                                <p>Conversation box title</p>
                                                            </div>
                                                            <div className='head-btns'>
                                                                <SVGIcons.ChatThemeMaximizeIcon />
                                                                <SVGIcons.ChatThemeCloseIcon />
                                                            </div>

                                                        </div>

                                                        <img className='chat-preview' src={AppIcons.chatPreview} alt="icon" />

                                                    </div>
                                                </Col>

                                                <Col span={15}>
                                                    <Form.Item
                                                        name="chatHeaderImg"
                                                        initialValue={formData?.chatHeaderImg}
                                                        style={{ marginBottom: '0px' }}
                                                    >
                                                        <Radio.Group
                                                            style={{ display: 'flex', flexWrap: 'wrap' }}
                                                            // onChange={handleHeaderChange}
                                                            disabled
                                                            className="custom-radio-group"
                                                            value={selectedHeader} // Controlled value
                                                        >
                                                            {Object.entries(headerImages).map(([key, src]) => (
                                                                <Radio
                                                                    key={key}
                                                                    value={key}
                                                                    style={{ flex: '0 0 48%', maxWidth: '48%', marginBottom: '30px' }}
                                                                >
                                                                    <img src={src} alt={`icon-${key}`} style={{ width: '100%', height: '100%' }} />
                                                                </Radio>
                                                            ))}
                                                        </Radio.Group>
                                                    </Form.Item>
                                                </Col>
                                            </Row>



                                        </Col>
                                        <Col span={12} >
                                            <br />
                                            <br />
                                            <Title level={4} style={{ margin: '0', fontWeight: '400' }}>{translateThis('Conversation box title')}</Title>
                                            <Paragraph>&nbsp;</Paragraph>

                                            <Form.Item
                                                label={translateThis("Title")}
                                                name="conversationBoxTitle"
                                                style={{ marginBottom: '52px' }}

                                            >
                                                <Input
                                                    disabled
                                                    value={formData.conversationBoxTitle}
                                                    onChange={(e) => setFormValue('conversationBoxTitle', e.target.value)}
                                                    placeholder={translateThis('Type here')} />
                                            </Form.Item>
                                        </Col>

                                        <Col span={24} >
                                            <br />
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Background color')}  🎨</Title>
                                            <br />
                                            <br />

                                            <Form.Item
                                                name="themeBackgroundColor"
                                                initialValue={formData?.themeBackgroundColor}
                                                className='themeBGSelector'
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Radio.Group
                                                    style={{ display: 'flex', flexWrap: 'wrap' }}
                                                    onChange={(e) => setFormValue('themeBackgroundColor', e.target.value)}
                                                    className="custom-radio-group"
                                                    disabled
                                                >

                                                    <Radio value="themeBGLight">
                                                        <div className='mobileThemeBG themeBGLight'>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                        <p>{translateThis('Light')}</p>
                                                    </Radio>
                                                    <Radio value="themeBGGrey">
                                                        {/* <img src={AppIcons.themeBGGrey} className='themeBGSelect' alt="background color" /> */}
                                                        <div className='mobileThemeBG themeBGGrey'>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                        <p>{translateThis('Grey')}</p>
                                                    </Radio>
                                                    <Radio value="themeBGDark">
                                                        {/* <img src={AppIcons.themeBGDark} className='themeBGSelect' alt="background color" /> */}
                                                        <div className='mobileThemeBG themeBGDark'>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                        <p>{translateThis('Dark')}</p>
                                                    </Radio>
                                                    <Radio value="themeBGColor">
                                                        {/* <img src={AppIcons.themeBGColor} className='themeBGSelect' alt="background color" /> */}
                                                        <div className='mobileThemeBG themeBGColor'>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                        <p>{translateThis('Color')}</p>
                                                    </Radio>
                                                    <Radio value="themeBGFlash">
                                                        {/* <img src={AppIcons.themeBGFlash} className='themeBGSelect' alt="background color" /> */}
                                                        <div className='mobileThemeBG themeBGFlash'>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                        <p>{translateThis('Flash')}</p>
                                                    </Radio>
                                                    <Radio value="themeBGDarkPurple">
                                                        {/* <img src={AppIcons.themeBGDarkPurple} className='themeBGSelect' alt="background color" /> */}
                                                        <div className='mobileThemeBG themeBGDarkPurple'>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                        <p>{translateThis('Dark Purple')}</p>
                                                    </Radio>

                                                </Radio.Group>
                                            </Form.Item>
                                        </Col>

                                        <Col span={24} >
                                            <br />
                                            <br />
                                            <Title level={3} style={{ margin: '0' }}>{translateThis('Preview your virtual Assistant')} 🎬</Title>
                                            <Paragraph>{translateThis('Your bot, ready to meet the world.')}</Paragraph>

                                            <Form.Item
                                                name="selectPreview"
                                                initialValue={formData?.selectPreview}
                                                style={{ marginBottom: '52px' }}
                                            >
                                                <Radio.Group
                                                    onChange={(e) => setFormValue('selectPreview', e.target.value)}
                                                >
                                                    <Radio value="desktop">{translateThis("Desktop")}</Radio>
                                                    <Radio value="mobile">{translateThis("Mobile")}</Radio>
                                                </Radio.Group>
                                            </Form.Item>


                                            {(formData?.selectPreview === 'desktop') ? <Row gutter={70}>
                                                <Col span={14}>

                                                    <div className='chat-preview-window f-wrp'>
                                                        <img className='chat-preview-smScreen' src={AppIcons.preview1} alt="icon" />
                                                        {formData?.avatarImg ? <div className='avatar-preview'>
                                                            <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                            {/* <img className='chat-head' src={selectedAvatar?.iconName} alt="Selected preview" /> */}
                                                        </div> : null}
                                                    </div>

                                                    {/* <div className='f-wrp' style={{ height: '100%' }}>
                                                <img className='chat-preview' src={AppIcons.preview1} alt="icon" style={{ width: '100%', height: '100%', objectFit: 'contain' }} />
                                            </div> */}

                                                </Col>
                                                <Col span={10}>
                                                    <div className='chat-preview-window f-wrp'>
                                                        <img className='chat-preview-smScreen' src={AppIcons.preview2} alt="icon" />
                                                        {formData?.avatarImg ? <div className='avatar-preview'>
                                                            <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                            {/* <img className='chat-head' src={selectedAvatar?.iconName} alt="Selected preview" /> */}
                                                        </div> : null}

                                                        <div className='f-wrp chat-preview-box' style={{ backgroundColor: '#261e35', borderRadius: '17px 17px 10px 10px' }}>

                                                            <div className={`mobileThemeBG ${formData?.themeBackgroundColor}`}>
                                                                <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                    <img
                                                                        className='chat-head'
                                                                        src={headerImages[selectedHeader]}
                                                                        alt="Selected preview"
                                                                    />
                                                                    <div className='title-box mobile-titleBox'>
                                                                        <div className='logo-upload-box f-wrp'>
                                                                            <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                        </div>
                                                                        <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                    </div>
                                                                    <div className='head-btns'>
                                                                        <SVGIcons.ChatThemeCloseIcon />
                                                                    </div>
                                                                </div>
                                                                <div className='message-box'>
                                                                    <div className='user-msg'>
                                                                        <span>Hello, how are you doing?</span>
                                                                    </div>
                                                                    <div className='bot-msg'>
                                                                        {formData?.avatarImg ? <div className='avatar-preview'>
                                                                            <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                        </div> : null}
                                                                        <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                    </div>
                                                                </div>
                                                                <div className='chat-box'>
                                                                    <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                                </div>
                                                            </div>

                                                            {/* <img
                                                                className='chat-head'
                                                                src={headerImages[selectedHeader]} // Dynamically show selected image
                                                                alt="Selected preview"
                                                            /> */}
                                                            <img className='chat-preview' src={AppIcons.ChatboxPreview} alt="icon" />
                                                        </div>
                                                    </div>
                                                </Col>
                                                <Col span={24}>

                                                    <div className={`chat-preview-window full-screen-preview f-wrp ${formData?.themeBackgroundColor}`}>
                                                        <img className='chat-preview-fullScreen' src={AppIcons.preview3} alt="icon" />
                                                        {formData?.avatarImg ? <div className='avatar-preview'>
                                                            <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                            {/* <img className='chat-head' src={selectedAvatar?.iconName} alt="Selected preview" /> */}
                                                        </div> : null}
                                                        <div className='f-wrp chat-preview-box'>
                                                            {/* <img
                                                                className='chat-head'
                                                                src={headerImages[selectedHeader]} // Dynamically show selected image
                                                                alt="Selected preview"
                                                            /> */}
                                                            <div className={`mobileThemeBG ${formData?.themeBackgroundColor}`}>
                                                                {/* <div className='header' >
                                                                    <img
                                                                        className='chat-head'
                                                                        src={headerImages[selectedHeader]}
                                                                        alt="Selected preview"
                                                                    />
                                                                    <img src={AppIcons.mobileThemeHeadLogo} alt='logo' />
                                                                    <img src={AppIcons.mobileThemeHeadClose} alt='close' />
                                                                </div> */}
                                                                <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                    <img
                                                                        className='chat-head'
                                                                        src={headerImages[selectedHeader]}
                                                                        alt="Selected preview"
                                                                    />
                                                                    <div className='title-box mobile-titleBox'>
                                                                        <div className='logo-upload-box f-wrp'>
                                                                            <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                        </div>
                                                                        <span>{formData?.conversationBoxTitle ? <>{formData?.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                    </div>
                                                                    <div className='head-btns'>
                                                                        <SVGIcons.ChatThemeMaximizeIcon />
                                                                        <SVGIcons.ChatThemeCloseIcon />
                                                                    </div>
                                                                </div>
                                                                <div className='message-box'>
                                                                    <div className='user-msg'>
                                                                        <span>Hello, how are you doing?</span>
                                                                    </div>
                                                                    <div className='bot-msg'>
                                                                        {formData?.avatarImg ? <div className='avatar-preview'>
                                                                            <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                        </div> : null}
                                                                        <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                    </div>
                                                                </div>
                                                                <div className='chat-box'>
                                                                    <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                                </div>
                                                            </div>

                                                            <img className='chat-preview' src={AppIcons.ChatWindowPreview} alt="icon" />
                                                        </div>
                                                    </div>

                                                </Col>
                                            </Row> : <Row gutter={70}>
                                                <Col span={14}>
                                                    <div className='mobile-preview-box'>
                                                        <div className={`mobileThemeBG ${formData?.themeBackgroundColor}`}>
                                                            <div className={`header ${formData?.isHeaderPresent ? 'header-added' : 'header-removed'}`} >
                                                                <img
                                                                    className='chat-head'
                                                                    src={headerImages[selectedHeader]}
                                                                    alt="Selected preview"
                                                                />
                                                                <div className='title-box mobile-titleBox'>
                                                                    <div className='logo-upload-box f-wrp'>
                                                                        <LogoPreview uploadedLogo={uploadedLogo} formData={formData} />
                                                                    </div>
                                                                    <span>{formData.conversationBoxTitle ? <>{formData.conversationBoxTitle}</> : <>PnP</>}</span>
                                                                </div>
                                                                <div className='head-btns'>
                                                                    <SVGIcons.ChatThemeCloseIcon />
                                                                </div>
                                                            </div>
                                                            <div className='message-box'>
                                                                <div className='user-msg'>
                                                                    <span>Hello, how are you doing?</span>
                                                                </div>
                                                                <div className='bot-msg'>
                                                                    {formData?.avatarImg ? <div className='avatar-preview'>
                                                                        <AvatarViewer className='chat-head' avatar={formData?.avatarImg} />
                                                                    </div> : null}
                                                                    <span>I'm doing well, thank you! How can I help <br />you today?</span>
                                                                </div>
                                                            </div>
                                                            <div className='chat-box'>
                                                                <img src={AppIcons.mobileThemeChatInput} alt='chat' />
                                                            </div>
                                                        </div>
                                                    </div>
                                                </Col>
                                            </Row>}
                                        </Col>
                                    </Row> : null}

                                {/* -------------------------------------- end of page three ----------------------------------------- */}

                                {currentFormStep === 3 ?
                                    <Row gutter={90}>
                                        <Col span={24} sm={24}>
                                            <br />
                                            <br />
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Module embedding URL')}</Title>
                                            <div className='module-url-wrp' style={{ marginBottom: '52px' }}>
                                                <span>{moduleEmbeddedURL}</span>

                                                <Button className='pln-btn' type="primary" title={translateThis('Copy')} shape="circle" onClick={copyEmbeddingURL} icon={<CopyOutlined />} />
                                                <Button className='pln-btn' type="primary" title={translateThis('Open in new tab')} shape="circle" onClick={() => window.open(moduleEmbeddedURL, '_blank')} icon={<ExportOutlined />} />


                                            </div>
                                        </Col>
                                        <Col span={24}>
                                            <br />
                                            <Title level={4} style={{ margin: '0' }}>{translateThis('Test module')}</Title>
                                            <Paragraph>&nbsp;</Paragraph>

                                            <div className='maxWidth985px'>
                                                <div className='chat-window-ui'>
                                                    <div className='chat-window'>
                                                        {isChatHistoryLoading ? <span>{translateThis('Loading training chat history...')}</span> : <>
                                                            {questions.length ? <div className="messaging">
                                                                <div className="inbox_msg">

                                                                    <div className="messages">
                                                                        <div className="msg_history" ref={chatScrollToBottomRef}>
                                                                            {questions.map((q, k) => <div key={k} className='each-chat-box'>

                                                                                <div className="outgoing_msg chat-message">
                                                                                    <p>{q.question}</p>
                                                                                </div>
                                                                                <div className="incoming_msg chat-message" >
                                                                                    {formData.avatarImg ? <AvatarViewer className='chatbotIcon' avatar={formData.avatarImg} /> :
                                                                                        <img className='chatbotIcon' src={AppIcons.chatBot} alt='chat bot' />}
                                                                                    <div className='formatted-text'>
                                                                                        {q.answer ? <TypingEffect markdown={q.answer} /> : null}
                                                                                    </div>

                                                                                </div>
                                                                            </div>)}
                                                                            {isAsking ? <>
                                                                                <div className="typing">
                                                                                    <span className="dot" />
                                                                                    <span className="dot" />
                                                                                    <span className="dot" />
                                                                                </div>
                                                                                {/* <div className="incoming_msg">
                                                                        <div className="received_msg">
                                                                            <p>{translateThis('Typing...')}</p>
                                                                        </div>
                                                                    </div> */}
                                                                            </> : null}
                                                                            <div style={{ padding: '10px' }} />
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div> : <div className="messaging" style={{ minHeight: '150px' }}>&nbsp;</div>}
                                                        </>}
                                                    </div>
                                                    <div className="chat-input module-chat">
                                                        <Form.Item
                                                            initialValue={question}
                                                        >

                                                            <Input.TextArea
                                                                autoSize={{ minRows: 2, maxRows: 4 }}
                                                                onKeyDown={(e) => {
                                                                    if (e.key === 'Enter' && !e.shiftKey) {
                                                                        e.preventDefault();
                                                                        askAi(question);
                                                                        setQuestion('');
                                                                    }
                                                                }} value={question}
                                                                onChange={(e) => setQuestion(e.target.value)}
                                                                style={{ resize: 'none' }}
                                                                placeholder={translateThis('Enter a question and hit Enter.')} />

                                                        </Form.Item>

                                                        <Button type="primary" disabled={!question || isAsking}
                                                            onClick={() => { askAi(question); setQuestion('') }}
                                                            className='sent-btn'
                                                            icon={<SVGIcons.SentIcon />} />
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>
                                        <Col span={24} >
                                            <br />
                                            <br />
                                            <div className='maxWidth985px'>
                                                <Row gutter={40}>
                                                    <Col span={12}>
                                                        <div className='embed-code-box'>
                                                            <Title level={4} style={{ margin: '0 0 30px 0' }}>{translateThis('Create the')} <b>{translateThis('URL')}</b><br />{translateThis('for your site')}</Title>

                                                            <div className='embed-url-wrp'>
                                                                {/* <span>{process.env.REACT_APP_AI_APP_URL}/{getCurrentFacilityURL()}/</span> */}
                                                                <span style={{ width: '0', position: 'absolute', opacity: '0' }}>{moduleEmbeddedURL}</span>
                                                                <Button className='fill-btn create-btn' type="primary" title={translateThis('Create URL')} shape="default" onClick={() => console.log('clicked')}>{translateThis('Create URL')}</Button>

                                                                <div className='code-copy-field'>
                                                                    <Form.Item name="name" style={{ margin: '0px' }}>
                                                                        <Input value={formData.name} prefix={`${process.env.REACT_APP_AI_APP_URL}/${getCurrentFacilityURL()}/`} suffix={`/chat`}
                                                                            onChange={(e) => setFormValue('name', e.target.value)} placeholder={translateThis('Type here')} />
                                                                    </Form.Item>
                                                                    <Button className='fill-btn' type="primary" title={translateThis('Copy')} shape="default" onClick={copyEmbeddingURL}>{translateThis('Copy')}</Button>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Col>
                                                    <Col span={12}>
                                                        <div className='embed-code-box'>
                                                            <Title level={4} style={{ margin: '0 0 30px 0' }}>{translateThis('Create the')} <b>{translateThis('<code />')}</b><br />{translateThis('for your site')}</Title>

                                                            <div className='embed-url-wrp'>
                                                                <Radio.Group
                                                                    value={widgetMode}
                                                                    disabled
                                                                    style={{ marginBottom: 12 }}
                                                                >
                                                                    <Radio value="bubble">{translateThis('Bubble')}</Radio>
                                                                    <Radio value="window">{translateThis('Window')}</Radio>
                                                                </Radio.Group>
                                                                <div className='code-copy-field'>
                                                                    <pre style={{
                                                                        width: '100%',
                                                                        margin: 0,
                                                                        padding: '8px 11px',
                                                                        fontFamily: 'monospace',
                                                                        fontSize: 12,
                                                                        background: '#f5f5f5',
                                                                        border: '1px solid #d9d9d9',
                                                                        borderRadius: 6,
                                                                        whiteSpace: 'pre-wrap',
                                                                        wordBreak: 'break-all',
                                                                        color: '#262626',
                                                                        minHeight: 100,
                                                                    }}>{formData.createdCode || translateThis('No embed code saved. Edit this agent to generate one.')}</pre>
                                                                    <Button className='fill-btn' type="primary" title={translateThis('Copy')} shape="default" onClick={copyEmbedCodeSnippet} disabled={!formData.createdCode}>{translateThis('Copy')}</Button>
                                                                </div>

                                                            </div>

                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                            <br />
                                            <br />
                                            <br />
                                            <br />
                                        </Col>
                                    </Row> : null}
                                {/* -------------------------------------- end of page four ----------------------------------------- */}

                            </Flex>
                        </div>

                        <div className='foot-btn-bar f-wrp'>
                            <div className="container">

                                <Flex gap={15} justify='space-between' align='center' horizontal="true" className='button-sec'>
                                    <Flex gap={15}>
                                        <Button className='cancel-btn' onClick={() => navigate(`/${getCurrentFacilityURL()}/ai-development/modules`, { replace: true })} type='default' htmlType="reset"> {translateThis("Back")} </Button>
                                    </Flex>
                                    <Flex gap={15}>
                                        <Button className='fill-btn arrow-button' disabled={currentFormStep === 0} onClick={() => {
                                            setCurrentFormStep(prev => Math.max(prev - 1, 0));
                                            scrollToTop.current?.scrollIntoView({ behavior: 'smooth' });
                                        }} shape="circle"><SVGIcons.ChevronLeftIcon /></Button>
                                        <Button className='fill-btn arrow-button' disabled={currentFormStep === totalSteps - 1} onClick={() => {
                                            setCurrentFormStep((prev) => Math.min(prev + 1, totalSteps - 1));
                                            scrollToTop.current?.scrollIntoView({ behavior: 'smooth' });
                                        }} shape="circle" ><SVGIcons.ChevronRightIcon /></Button>
                                    </Flex>
                                    <Flex gap={15}>
                                        <Button className='fill-btn' onClick={() => navigate(`/${getCurrentFacilityURL()}/ai-development/edit-module/${id}`, { replace: true })} type="primary" htmlType="submit"> {translateThis("Edit")} </Button>
                                    </Flex>
                                </Flex>
                            </div>
                        </div>
                    </Form> : <span>{translateThis('Loading..')}</span>}
                </div>
            </div>
        </PageLayout >
    );
}
